import React from "react";
import Body from "./Body";

const MarketingEx = () => {
  const _this = {  };
  return <Body {..._this} />;
};

export default MarketingEx;
